<div class="chart-wrapper">
  <canvas baseChart height="400" width="560" [datasets]="lineChartData" [labels]="lineChartLabels"
    [options]="lineChartOptions" [colors]="lineChartColors" [plugins]="lineChartPlugins" [legend]="lineChartLegend"
    [chartType]="lineChartType">
  </canvas>
</div>
